import Vue from 'vue';

const limit = 10;
export const profileService = {
  async getUserLogins(uid) {
    return Vue.axios.get(`/event-log/access/${uid}?limit=${limit}`).then(response => response.data);
  },
  async getUserActions(uid) {
    return Vue.axios
      .get(`/event-log/actions/${uid}?limit=${limit}`)
      .then(response => response.data);
  },
  async getUserViews(uid) {
    return Vue.axios.get(`/event-log/views/${uid}?limit=${limit}`).then(response => response.data);
  },
  async fetchUserDetails(userReferenceNumber) {
    return Vue.axios.get(`/users/${userReferenceNumber}`).then(response => response.data);
  },
  async saveUserDetails(roles, id, isActive) {
    return Vue.axios
      .post(`/users/${id}`, {
        roles,
        isActive
      })
      .then(response => response.data);
  },
  async impersonateUser(userName) {
    return Vue.axios.get(`session/${userName}/impersonate`).then(response => response.data);
  },
  async sendChangeInstructions(username, email) {
    return Vue.axios
      .post(`account/password-reset`, {
        username,
        email
      })
      .then(response => response.data);
  }
};
